import React, { useMemo } from 'react';
import { BANNER_TYPE_LANDSCAPE } from 'components/banner/utils/constant';
import { Banner, BannerBasic } from 'components/banner';
import { Wrapper } from 'components/wrapper';

import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type BannerLandscapeProps = {
  data?: Banner;
  removePaddingLeft?: boolean;
  removePaddingRight?: boolean;
  removePaddingHorizontal?: boolean;
};

export const BannerLandscape = ({ removePaddingLeft, removePaddingRight, data }: BannerLandscapeProps) => {
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const { isMobile } = useWindowSize();

  const { noPaddingLeft, noPaddingRight } = useMemo(() => {
    const isMD = isMobile ? false : true;
    return {
      noPaddingLeft: isMD ? removePaddingLeft : false,
      noPaddingRight: isMD && isOpen ? removePaddingRight : false,
    };
  }, [isOpen, isMobile, removePaddingLeft, removePaddingRight]);

  if (!data) {
    return null;
  }

  return (
    <Wrapper noPaddingLeft={noPaddingLeft} noPaddingRight={noPaddingRight} bgColorTransparent>
      <BannerBasic dataBanner={data} bannerType={BANNER_TYPE_LANDSCAPE} />
    </Wrapper>
  );
};